var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tiktok",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.079,
    y1: 0.885,
    x2: 0.902,
    y2: 0.158,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5053c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#c90441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#f0014b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff004f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.067,
    y1: 0.896,
    x2: 0.934,
    y2: 0.13,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b2c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#00c8d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#00e6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f1ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.497,
    y1: 1.391,
    x2: 1.527,
    y2: -0.39,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dde3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcf7f7"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7427",
    "data-name": "Rectangle 7427",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17809",
    "data-name": "Group 17809",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11074",
    "data-name": "Path 11074",
    d: "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z",
    fill: "#1dbbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11075",
    "data-name": "Path 11075",
    d: "M141.528,117.71a2.544,2.544,0,0,1-2.544-2.544h-1.818v7.117a1.546,1.546,0,1,1-1.109-1.484v-1.767a3.28,3.28,0,1,0,2.842,3.251l.053-3.6a4.342,4.342,0,0,0,2.576.842Z",
    transform: "translate(-127.686 -111.117)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11076",
    "data-name": "Path 11076",
    d: "M127.864,103.627a2.544,2.544,0,0,1-2.544-2.544H123.5V108.2a1.546,1.546,0,1,1-1.109-1.484v-1.767a3.28,3.28,0,1,0,2.842,3.251l.053-3.6a4.342,4.342,0,0,0,2.576.842Z",
    transform: "translate(-114.503 -97.529)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11077",
    "data-name": "Path 11077",
    d: "M141.062,117.666a4.008,4.008,0,0,1-2.5-2.5h-1.385v7.117a1.867,1.867,0,1,1-1.59-1.979V119a2.981,2.981,0,1,0,2.842,2.784l.053-3.6a4.342,4.342,0,0,0,2.576.842Z",
    transform: "translate(-127.7 -111.118)",
    fill: "url(#linear-gradient-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTiktok);
export default __webpack_public_path__ + "static/media/blue-tiktok.bf4135d2999633e6ac89c3a164314b8b.svg";
export { ForwardRef as ReactComponent };